import {createContext, useContext} from 'react';

import type {
  ButtonDataViewAction,
  CustomDataViewButton,
  OverflowDataViewAction,
} from 'analysis-tool/data-view/DataViewContext';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import {PipelineStep} from 'pipelines/PipelineTypes';

import {LayoutEvent, LayoutPath} from './DataLayoutTypes';

export interface AdditionalBlockActions {
  buttonActions?: Array<ButtonDataViewAction | CustomDataViewButton>;
  overflowActions?: Array<OverflowDataViewAction>;
}

/**
 * @package
 */
export interface DataLayoutContextValue {
  actionOrigin: ActionOrigin;
  additionalBlockActions?: Record<string, AdditionalBlockActions>;
  clientId: string;
  expandedBlockPath?: LayoutPath | null;
  isEditable?: boolean;
  onExpandBlock?: (layoutPath: LayoutPath) => void;
  onCollapseBlock?: () => void;
  onEvents?: (events: Array<LayoutEvent>) => void;
  steps?: ReadonlyArray<PipelineStep>;
}

const DataLayoutContext = createContext<DataLayoutContextValue>(undefined as never);

/**
 * Context for `DataLayout`.
 *
 * @package
 */
export default DataLayoutContext;

export function useDataLayoutContext(): DataLayoutContextValue {
  const context = useContext(DataLayoutContext);
  if (!context) {
    throw new Error('DataLayoutContext not found. If this is a test, use DataLayoutTestWrapper.');
  }

  return context;
}
